import * as React from 'react';

import { Api } from '../../typings/api';
import { ListDisplayType } from '../../containers/DriveItemList/constants';
import { LoaderStep } from '../Loader';
import DriveItemUtils, { ThumbnailDescriptor } from '../../utils/driveItem';
import ListItem from '../ListItem';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import UserAgentUtils from '../../utils/userAgent';
import { createNotification } from '../../containers/NotificationBar/actions';
import { viewDriveItem, DriveItemOrigin } from '../../containers/DriveItemList/actions';

interface DriveItemProps {
	driveItem: Api.DriveItem;
	showUnreadBadge: boolean;
	displayType: ListDisplayType;
	dispatch: Dispatch<StoreState>;
	isSelectedForContextualMenu: boolean;
	isDownloading: boolean;
	isDownloaded: boolean;
	isDownloadInProgress: boolean;
	isUpdating: boolean;
	isDeletionInProgress: boolean;
	isMarkingItemForDeletion: boolean;
	loaderStep: LoaderStep | undefined;
	thumbnailDescriptor: ThumbnailDescriptor;
	isUnread: boolean;
	isEditMode: boolean;
	hasActions?: boolean;
	hasSelectionIcon?: boolean;
	onClick?: () => void;
	isDraggable?: boolean;
	index?: number;
	itemsCount?: number;
	draggableItemsCount?: number;
	isDragPreview?: boolean;
	isMultipleSelection?: boolean;
	isSelectedInMultipleSelection?: boolean;
	tagClasses: string[] | undefined;
}

const DriveItem = ({
	driveItem,
	showUnreadBadge,
	displayType,
	dispatch,
	isSelectedForContextualMenu,
	isDownloading,
	isDownloaded,
	isDownloadInProgress,
	isUpdating,
	isDeletionInProgress,
	isMarkingItemForDeletion,
	loaderStep,
	thumbnailDescriptor,
	isUnread,
	isDraggable,
	index,
	hasActions = true,
	hasSelectionIcon = true,
	onClick,
	itemsCount,
	draggableItemsCount,
	isDragPreview,
	isEditMode,
	isMultipleSelection,
	isSelectedInMultipleSelection,
	tagClasses,
}: DriveItemProps) => {
	const handleClick = () => {
		if (onClick) {
			return onClick();
		}

		const isDirectory = driveItem.type === Api.DriveItemType.Directory;
		const isImage = driveItem.type === Api.DriveItemType.Image;
		const isAlwaysViewable = isDirectory || isImage;
		const isOnline = UserAgentUtils.isOnline();
		const isNotViewable = !isOnline && !isDownloaded && !isAlwaysViewable;

		if (isNotViewable) {
			dispatch(createNotification('info.offline_download_single_asset'));
			return;
		}

		dispatch(viewDriveItem(driveItem, DriveItemOrigin.List));
	};

	return (
		<ListItem
			onClick={handleClick}
			showUnreadBadge={showUnreadBadge}
			displayType={displayType}
			itemType={driveItem.type}
			itemId={driveItem.id}
			hasActionButton={hasActions}
			hasSelectionIcon={hasSelectionIcon}
			label={DriveItemUtils.getDisplayName(driveItem)}
			isSelectedForContextualMenu={isSelectedForContextualMenu}
			isDownloading={isDownloading}
			isDownloaded={isDownloaded}
			isDownloadInProgress={isDownloadInProgress}
			isMarkingItemForDeletion={isMarkingItemForDeletion}
			isUpdating={isUpdating}
			isDeletionInProgress={isDeletionInProgress}
			loaderStep={loaderStep}
			thumbnailDescriptor={thumbnailDescriptor}
			isUnread={isUnread}
			isEditMode={isEditMode}
			isDraggable={isEditMode && isDraggable}
			index={index}
			item={driveItem}
			itemsCount={itemsCount}
			draggableItemsCount={draggableItemsCount}
			isDragPreview={isDragPreview}
			isMultipleSelection={isMultipleSelection}
			isSelectedInMultipleSelection={isSelectedInMultipleSelection}
			tagClasses={tagClasses}
		/>
	);
};

export default DriveItem;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/index.tsx